import dTicketColoredSrc from './svg/dTicketIconColored.svg?url';
import dTicketMonoSrc from './svg/dTicketIconMono.svg?url';
import dTicketColoredWithTextSrc from './svg/dTicketIconWithTextColored.svg?url';

export enum EDTicketIconVariants {
	Primary = 'PRIMARY',
	COLORED = 'COLORED',
	COLORED_WITH_TEXT = 'COLORED_WITH_TEXT',
}

export enum EDTicketSize {
	Small = 'SMALL',
	Large = 'LARGE',
}

export interface IDTicketIconProps {
	variant?: EDTicketIconVariants;
	size?: EDTicketSize;
}

const variantToSrc = {
	[EDTicketIconVariants.Primary]: dTicketMonoSrc,
	[EDTicketIconVariants.COLORED]: dTicketColoredSrc,
	[EDTicketIconVariants.COLORED_WITH_TEXT]: dTicketColoredWithTextSrc,
};

function getSizeInPixels(
	variant: EDTicketIconVariants,
	size: EDTicketSize
): number {
	if (size === EDTicketSize.Large) {
		return 60;
	}
	if (
		size === EDTicketSize.Small &&
		variant === EDTicketIconVariants.COLORED_WITH_TEXT
	) {
		return 32;
	}
	return 24;
}

export const DTicketIconV2 = ({
	variant = EDTicketIconVariants.Primary,
	size = EDTicketSize.Small,
}: IDTicketIconProps) => {
	const sizeInPixels = getSizeInPixels(variant, size);
	const src = variantToSrc[variant];
	return (
		<img
			src={src}
			alt="DTicket icon"
			width={sizeInPixels}
			height={sizeInPixels}
		/>
	);
};
